import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Box, Heading, Row } from "@stenajs-webui/core";
import { CloseButton, Icon } from "@stenajs-webui/elements";
import { cssColor } from "@stenajs-webui/theme";
import type { FC, ReactNode } from "react";

export interface PopoverTitleProps {
  className?: string;
  closeButtonClassName?: string;
  contentAfterHeading?: ReactNode;
  contentLeft?: ReactNode;
  icon?: IconDefinition;
  iconColor?: string;
  onClose?: () => void;
  text?: string;
}

export const PopoverTitle: FC<PopoverTitleProps> = ({
  onClose,
  icon,
  iconColor = cssColor("--lhds-color-ui-700"),
  contentLeft,
  className,
  text,
  contentAfterHeading,
  closeButtonClassName,
}) => {
  return (
    <Row
      alignItems="center"
      className={className}
      justifyContent={"space-between"}
      indent={1}
      spacing={1}
    >
      <Row alignItems="center" gap={2} indent={2}>
        {contentLeft} {icon && <Icon icon={icon} size={16} color={iconColor} />}
        {text && (
          <Heading variant={"h5"} as={"h2"}>
            {text}
          </Heading>
        )}
        {contentAfterHeading}
      </Row>
      {onClose && (
        <Box alignSelf={"flex-start"}>
          <CloseButton className={closeButtonClassName} onClick={onClose} />
        </Box>
      )}
    </Row>
  );
};
